import {
  formEncode,
  getToken,
  handleResponse,
  nextFormDataApi,
  nextJsonApi,
} from '@/API/core';

const workersComp = {
  fetchRowData: async (data: { company_id: string }, empId?: string) => {
    let response = null;
    const token = await getToken();
    try {
      if (!empId) {
        response = await nextJsonApi.post(
          '/workers-comp/row-data',
          formEncode(data),
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else
        response = await nextJsonApi.post(
          `/workers-comp/row-data/${empId}`,
          formEncode(data),
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  fetchCompanies: async (data: { company_id?: Number }) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post(
        '/insurance-claim/company',
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  fetchLocations: async (
    franchise: string,
    data: { company_id: Number | undefined }
  ) => {
    const token = await getToken();
    let response = null;
    try {
      response = await nextJsonApi.post(
        `/insurance-claim/location/${franchise}`,
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  fetchInsuranceList: async (data: { company_id: string }) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post(
        '/insurance-claim/insurance',
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  insertData: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextFormDataApi.post(
        '/insurance-claim/insert',
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  acceptWorkersForm: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextFormDataApi.post(
        '/workers-comp/accept-claim',
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  editWorkersForm: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextFormDataApi.post(
        '/workers-comp/edit-claim',
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  denyWorkersForm: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post(
        '/workers-comp/deny-claim',
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  deleteWorkersForm: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post(
        `/workers-comp/delete`,
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default workersComp;
